import DropViewState from '../store/schema/DropViewState';
import { action } from 'satcheljs/lib/legacy';

// Set Drop state, should be called only from Droppable component
export default action('setDropState')(function(
    viewState: DropViewState,
    isDragOver: boolean,
    draggableItemType: string
): void {
    viewState.isDragOver = isDragOver;
    viewState.draggableItemType = draggableItemType;
});
